export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-11-cc920d6e2e46729b77e230caddc22cf8.jpg";